
import { useState, useEffect, useRef } from "react";
import SondaggioService from "../../../../services/SondaggiService";
import RisposteSondaggioService from "../../../../services/RisposteSondaggioService";
import { Container, Row, Col, FormControl } from "react-bootstrap"
import { Button, InputGroup } from "react-bootstrap"
import { GoSearch } from "react-icons/go"
import { FiChevronLeft } from 'react-icons/fi'
import { PiFileCsv } from "react-icons/pi";
import { Spinner } from "react-bootstrap";
import DomandaGrafico from "./DomandaGrafico";
import DomandaGraficoPdfContent from './DomandaGraficoPDFContent';
import PartecipanteService from "../../../../services/PartecipanteService";
import SondaggioPartecipanteService from "../../../../services/SondaggioPartecipanteService";
import CardRispondenti from './CardRispondenti';
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import {
  Chart as ChartJS,
  ArcElement,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
  Colors
} from 'chart.js';

ChartJS.register(ArcElement, BarElement, CategoryScale, LinearScale, Tooltip, Legend);

/*
props
<RisposteElenco
comune={props.comune}
sondaggi={sondaggi}
sonId={sonId}
setMostraTabella={props.setMostraTabella}
setGestisci={setGestisci}
gestisci={gestisci}
/>
*/
export default function RisposteElenco(props) {
  const [caricandoSondaggioERisposte, setCaricandiSondaggioERisposte] = useState(true) // stato per identificare se sta caricando sondaggio e risposte 
  const [sondaggio, setSondaggio] = useState(null)
  const [risposte, setRisposte] = useState(null)
  //const [partecipantiTotali, setPartecipantiTotali] = useState(null);
  //const [utentiRispondenti, setUtentiRispondenti] = useState([]);
  const [domDomanda, setDomDomanda] = useState("")

  const elementRefs = useRef({}); // Oggetto per mappare ID -> elemento DOM
  const pdfElementRefs = useRef({}); // Nuovo ref per gli elementi da catturare

  const [sezioniVisibili, setSezioniVisibili] = useState({});
  const [datiFasceEta, setDatiFasceEta] = useState([])

  const [sezioniEspanse, setSezioniEspanse] = useState({});

  const [datiPunteggiGrafico, setDatiPunteggiGrafico] = useState({labels: [], data: []});

  const [datiGraficoTempo, setDatiGraficoTempo] = useState({ labels: [], data: [] });
  const [totalePartecipantiSondaggio, setTotalePartecipantiSondaggio] = useState(null)

  const [dataInizioSondaggio, setDataInizioSondaggio] = useState(null)
  const [dataFineSondaggio, setDataFineSondaggio] = useState(null)
  const [exportingPdf, setExportingPdf] = useState(false);


  const toggleSezione = (sezId) => {
    setSezioniVisibili(prev => {
      const currentState = prev[sezId];
      // Se la chiave non esiste (undefined), il primo click la imposta a false (collassa).
      // Se esiste, la inverte.
      const newState = prev.hasOwnProperty(sezId) ? !currentState : false;
      return {
        ...prev,
        [sezId]: newState
      };
    });
  };


  const redirectToList = () => {
    props.setMostraTabella(true)
  }

  const dataEtaPartecipante = {
    labels: Object.keys(datiFasceEta),
    datasets: [{
      label: 'Partecipanti',
      data: Object.values(datiFasceEta),
      backgroundColor: ['#0d6efd', '#6c757d', '#198754', '#ffc107', '#dc3545'],
    }]
  };


  useEffect(() => {
    //prima riprendere il sondaggio corretto in base all'id passato nelle props
    setCaricandiSondaggioERisposte(true);
    SondaggioService.getSondaggioById(props.sonId)
      .then(res => {
        const sondaggio = res.data;

        setSondaggio(sondaggio)
        setDataInizioSondaggio(sondaggio.sonDataInizio)
        setDataFineSondaggio(sondaggio.sonDataChiusura)
        RisposteSondaggioService.getRisposteBySondaggio(props.sonId)
          .then(res => setRisposte(res.data))
          .catch(err => console.error("Errore nel recupero risposte", err));

        SondaggioPartecipanteService.getTotalePartecipantiSondaggio(props.sonId)
          .then(res => {
            setTotalePartecipantiSondaggio(res.data)
          })
          .catch(err => console.err("Errore nel recupero dei partecipanti al sondaggio", err))

          SondaggioPartecipanteService.getPunteggiPartecipanti(props.sonId)
          .then(res => {
            const dati = res.data;

    const labels = dati.map(item => `${item.intPunDescrizione} (${item.intPunMin}-${item.intPunMax})`);
    const data = dati.map(item => item.countPersoneConPunteggio);

    setDatiPunteggiGrafico({
      labels: labels,
      data: data
    });

    console.log("Punteggi per banda:", labels, data);
            /*
            0
: 
{intPunMin: 0, intPunMax: 3, intPunDescrizione: "basso", countPersoneConPunteggio: 0}
1
: 
{intPunMin: 4, intPunMax: 5, intPunDescrizione: "medio", countPersoneConPunteggio: 1}
2
: 
{intPunMin: 6, intPunMax: 7, intPunDescrizione: "alto", countPersoneConPunteggio: 1}
countPersoneConPunteggio
: 
1
intPunDescrizione
: 
"alto"
intPunMax
: 
7
intPunMin
: 
6
            */
          })
          .catch(err => console.error("Errore nel recupero dei partecipanti al sondaggio", err))
        SondaggioPartecipanteService.getPartecipantiEtaBySondaggio(props.sonId)
          .then(res => {
            const dati = res.data;
            console.log("res.data sondaggio partecipanti: ", res.data)
            const now = new Date();
            const fasceEta = {
              '18-24': 0,
              '25-34': 0,
              '35-44': 0,
              '45-54': 0,
              '55+': 0
            };

            dati.forEach(p => {
              if (!p.dataNascita) return;
              const nascita = new Date(p.dataNascita);
              const age = now.getFullYear() - nascita.getFullYear();

              if (age < 25) fasceEta['18-24']++;
              else if (age < 35) fasceEta['25-34']++;
              else if (age < 45) fasceEta['35-44']++;
              else if (age < 55) fasceEta['45-54']++;
              else fasceEta['55+']++;
            });

            setDatiFasceEta(fasceEta);

            // Costruisci oggetto con date e numero partecipazioni
            const conteggioPerData = {};

            dati.forEach(p => {
              if (!p.dataPartecipazione) return;
              const date = new Date(p.dataPartecipazione).toISOString().split('T')[0]; // "YYYY-MM-DD"
              conteggioPerData[date] = (conteggioPerData[date] || 0) + 1;
            });

            // Ordina le date
            const dateLabels = Object.keys(conteggioPerData).sort();
            console.log("dateLabels", dateLabels)
            // Crea andamento cumulativo
            let cumulato = 0;
            const datiCumulativi = dateLabels.map(date => {
              cumulato += conteggioPerData[date];
              return { x: date, y: cumulato };
            });
            console.log("datiCumulativi", datiCumulativi)

            // Salva nel tuo stato
            setDatiGraficoTempo({
              labels: dateLabels,
              data: datiCumulativi
            });
          })
          .catch(err => {
            console.log(err)
          });

      })
      .catch(err => {
        console.error("Errore nel caricamento del sondaggio:", err);
      })
      .finally(() => {
        setCaricandiSondaggioERisposte(false);
      });


    //Riprende il totale dei partecipanti presenti sul sistema per quel comune
    /*PartecipanteService.getTotalePartecipanti(props.comune.comId)
      .then(res => {
        setPartecipantiTotali(res.data);

      })
      .catch(err => console.error("Errore nel recupero partecipanti totali:", err));*/
  }, [props.gestisci])


  const sezioniFiltrate = sondaggio?.sezioni?.map(sezione => {
    const domandeFiltrate = sezione?.domande?.filter(domanda => {
      const matchDomanda = domanda?.domDomanda?.toLowerCase().includes(domDomanda.toLowerCase());
      const matchSezione = sezione?.sezNome?.toLowerCase().includes(domDomanda.toLowerCase());
      return matchDomanda || matchSezione;
    });

    return {
      ...sezione,
      domande: domandeFiltrate
    };
  }).filter(sezione => sezione.domande.length > 0); // rimuove le sezioni senza domande da mostrare


  const esportaPDF = async () => {

    if (!sondaggio || !risposte || exportingPdf) return;
    setExportingPdf(true);
    const doc = new jsPDF("p", "mm", "a4");
    const pageHeight = doc.internal.pageSize.height;
    const pageWidth = doc.internal.pageSize.width;
    const margin = 12; // Margine sinistro/destro
    const contentWidth = pageWidth - 2 * margin; // Larghezza utile
    let y = margin; // Posizione Y iniziale

    const pdfRefsMap = pdfElementRefs.current; // Usa il  ref

    // Funzione helper per gestire i cambi pagina
    const addPageIfNeeded = (neededHeight) => {
      if (y + neededHeight > pageHeight - margin) {
        doc.addPage();
        return margin; // Reset y to top margin
      }
      return y;
    };

    try {
      // --- PASSO 1: Calcola Altezza Totale Intestazione ---
      let totalHeaderHeight = 0;
      const tempDoc = new jsPDF("p", "mm", "a4"); // Usa un doc temporaneo per calcoli
      const centerX = pageWidth / 2;

      // Altezza Titolo
      tempDoc.setFontSize(25);
      tempDoc.setFont(undefined, 'bold');
      totalHeaderHeight += tempDoc.getTextDimensions(sondaggio.sonTitolo || 'Sondaggio', { fontSize: 16, fontStyle: 'bold' }).h + 6; // + spazio sotto

      // Altezza Descrizione
      tempDoc.setFontSize(16);
      tempDoc.setFont(undefined, 'normal');
      let descHeight = 0;
      if (sondaggio.sonDescrizione) {
        const descLines = tempDoc.splitTextToSize(sondaggio.sonDescrizione, contentWidth);
        descHeight = tempDoc.getTextDimensions(descLines).h;
        totalHeaderHeight += descHeight + 4; // + spazio sotto
      }

      // Altezza Periodo
      let periodoHeight = 0;
      if (dataInizioSondaggio && dataFineSondaggio) {
        const periodoText = `${new Date(dataInizioSondaggio).toLocaleDateString()} - ${new Date(dataFineSondaggio).toLocaleDateString()}`;
        periodoHeight = tempDoc.getTextDimensions(periodoText, { maxWidth: contentWidth }).h;
        totalHeaderHeight += periodoHeight + 10; // + spazio sotto
      } else {
        totalHeaderHeight += 10; // Spazio aggiunto anche se non c'è periodo
      }

      // Altezza Banner (richiede caricamento immagine)
      let bannerHeight = 0;
      if (sondaggio?.sonBanner && sondaggio?.sonBannerNome) {
        const ext = sondaggio.sonBannerNome.split(".").pop()?.toLowerCase();
        const mime = ext === "jpg" || ext === "jpeg" ? "image/jpeg" : "image/png";
        const bannerDataUrl = `data:${mime};base64,${sondaggio.sonBanner}`;
        const bannerImg = new Image();
        bannerImg.src = bannerDataUrl;
        try {
          await new Promise((resolve, reject) => {
            bannerImg.onload = resolve;
            bannerImg.onerror = reject; // Gestisci errore caricamento
          });
          bannerHeight = (bannerImg.height * contentWidth) / bannerImg.width;
          totalHeaderHeight += bannerHeight + 10; // + spazio sotto
        } catch (imgError) {
          console.error("Errore caricamento banner per calcolo altezza:", imgError);
          // Non aggiungere altezza banner se non si carica
        }
      }
      // Rimuovi l'ultimo spazio aggiunto se non c'è banner o se non si è caricato
      if (bannerHeight === 0) {
        if (periodoHeight > 0) totalHeaderHeight -= 10; // Rimuovi spazio dopo periodo
        else if (descHeight > 0) totalHeaderHeight -= 4; // Rimuovi spazio dopo descrizione
        else totalHeaderHeight -= 6; // Rimuovi spazio dopo titolo
      }


      // --- PASSO 2: Calcola Y Iniziale per Centratura Verticale ---
      const availableHeight = pageHeight - 2 * margin;
      let startY = margin; // Default: inizia dal margine superiore

      if (totalHeaderHeight < availableHeight) {
        // Solo se l'altezza totale è minore dello spazio disponibile
        startY = margin + (availableHeight - totalHeaderHeight) / 2;
      }
      y = startY; // Imposta la y iniziale calcolata

      // --- PASSO 3: Disegna Effettivamente gli Elementi ---

      // Titolo
      doc.setFontSize(25);
      doc.setFont(undefined, 'bold');
      doc.text(sondaggio.sonTitolo || 'Sondaggio', centerX, y, { align: 'center' });
      y += doc.getTextDimensions(sondaggio.sonTitolo || 'Sondaggio', { fontSize: 16, fontStyle: 'bold' }).h + 6;
      doc.setFont(undefined, 'normal');
      doc.setFontSize(16);

      // Descrizione
      if (sondaggio.sonDescrizione) {
        // Usa l'altezza già calcolata 'descHeight'
        doc.text(sondaggio.sonDescrizione, centerX, y, { align: 'center', maxWidth: contentWidth });
        y += descHeight + 4;
      }

      // Periodo
      if (dataInizioSondaggio && dataFineSondaggio) {
        // Usa l'altezza già calcolata 'periodoHeight'
        const periodoText = `${new Date(dataInizioSondaggio).toLocaleDateString()} - ${new Date(dataFineSondaggio).toLocaleDateString()}`;
        doc.text(periodoText, centerX, y, { align: 'center', maxWidth: contentWidth });
        y += periodoHeight + 10;
      } else {
        y += 10; // Spazio aggiunto anche se non c'è periodo
      }

      // Banner
      if (bannerHeight > 0) { // Disegna solo se l'altezza è stata calcolata correttamente
        // Ricarica l'immagine o usa quella già caricata se l'hai salvata
        const ext = sondaggio.sonBannerNome.split(".").pop()?.toLowerCase();
        const mime = ext === "jpg" || ext === "jpeg" ? "image/jpeg" : "image/png";
        const bannerDataUrl = `data:${mime};base64,${sondaggio.sonBanner}`;
        // Non serve await qui se l'immagine è già stata caricata per il calcolo altezza
        doc.addImage(bannerDataUrl, mime.toUpperCase().replace('JPEG', 'JPG'), margin, y, contentWidth, bannerHeight);
        y += bannerHeight + 10;
      }
      // Rimuovi l'ultimo spazio se non c'era banner
      if (bannerHeight === 0) {
        if (periodoHeight > 0) y -= 10;
        else if (descHeight > 0) y -= 4;
        else y -= 6;
      }


      // --- Cambio Pagina Forzato ---
      doc.addPage();
      y = margin; // Resetta y per la nuova pagina

      const allSectionsSorted = sondaggio.sezioni
        .sort((a, b) => a.sezPosizione - b.sezPosizione);

      for (const sezione of allSectionsSorted) {

        // ***** INIZIO: Aggiungi Titolo Sezione *****
        const sezioneTitle = `Sezione ${sezione.sezPosizione} - ${sezione.sezNome}`;
        doc.setFontSize(14); // Dimensione font per titolo sezione
        doc.setFont(undefined, 'bold'); // Grassetto per titolo sezione
        const titleHeightEst = doc.getTextDimensions(sezioneTitle, { maxWidth: contentWidth, fontSize: 14 }).h; // Stima altezza titolo
        const neededSpaceForTitle = titleHeightEst + 8; // Altezza titolo + spazio sotto

        y = addPageIfNeeded(neededSpaceForTitle); // Controlla se c'è spazio PRIMA di scrivere il titolo

        doc.text(sezioneTitle, margin, y, { maxWidth: contentWidth });
        y += titleHeightEst + 8; // Incrementa y DOPO aver scritto il titolo + spazio

        // Reimposta font per le domande (se necessario)
        doc.setFontSize(11); // O la dimensione che usi in DomandaGraficoPdfContent per h6
        doc.setFont(undefined, 'normal');
        // ***** FINE: Aggiungi Titolo Sezione *****


        const domandeOrdinate = sezione.domande
          .sort((a, b) => a.domNumPosizione - b.domNumPosizione);

        for (const domanda of domandeOrdinate) {
          const elementToCapture = pdfRefsMap[`pdf-domanda-${domanda.domId}`];

          if (elementToCapture) {
            try {
              await new Promise(resolve => setTimeout(resolve, 100)); // Delay

              const scale = 2;
              const canvas = await html2canvas(elementToCapture, {
                scale: scale,
                useCORS: true,
                logging: false,
                backgroundColor: '#ffffff',
                scrollX: 0,
                scrollY: -window.scrollY,
                windowWidth: elementToCapture.scrollWidth,
                windowHeight: elementToCapture.scrollHeight
              });
              const imgData = canvas.toDataURL("image/png", 1.0);

              const imgProps = doc.getImageProperties(imgData);
              const pdfImgWidth = contentWidth;
              const pdfImgHeight = (imgProps.height * pdfImgWidth) / imgProps.width;

              // Controlla spazio per l'immagine della domanda
              y = addPageIfNeeded(pdfImgHeight + 10); // Spazio per immagine + margine sotto

              doc.addImage(imgData, "PNG", margin, y, pdfImgWidth, pdfImgHeight);
              y += pdfImgHeight + 10; // Spazio dopo l'immagine

            } catch (canvasError) {
              console.error(`Errore html2canvas per domanda ${domanda.domId}:`, canvasError);
              const errorText = `D${domanda.domNumPosizione} - ${domanda.domDomanda} (Errore generazione grafico)`;
              const errorHeight = doc.getTextDimensions(errorText, { maxWidth: contentWidth, fontSize: 10 }).h;
              y = addPageIfNeeded(errorHeight + 5);
              doc.setFontSize(10);
              doc.setTextColor(255, 0, 0);
              doc.text(errorText, margin, y, { maxWidth: contentWidth });
              y += errorHeight + 5;
              doc.setTextColor(0, 0, 0);
              doc.setFontSize(11); // Reimposta dimensione font
            }
          } else {
            console.warn(`Ref PDF non trovato per pdf-domanda-${domanda.domId}. Skipping in PDF.`);
            const warningText = `D${domanda.domNumPosizione} - ${domanda.domDomanda} (Elemento non catturato)`;
            const warningHeight = doc.getTextDimensions(warningText, { maxWidth: contentWidth, fontSize: 10 }).h;
            y = addPageIfNeeded(warningHeight + 5);
            doc.setFontSize(10);
            doc.setTextColor(150, 150, 0);
            doc.text(warningText, margin, y, { maxWidth: contentWidth });
            y += warningHeight + 5;
            doc.setTextColor(0, 0, 0);
            doc.setFontSize(11); // Reimposta dimensione font
          }
        } // Fine loop domande

        // Aggiungi un po' di spazio extra tra la fine di una sezione e l'inizio della successiva (o la fine pagina)
        y += 5;

      } // Fine loop sezioni

      doc.save(`report_${sondaggio?.sonTitolo?.replace(/[^a-z0-9]/gi, '_') || 'sondaggio'}.pdf`);

    } catch (error) {
      console.error("Errore durante l'esportazione PDF:", error);
      // Mostra messaggio errore all'utente
    } finally {
      setExportingPdf(false); // Nascondi spinner
    }
  };


  return (
    <>

      <Container className="p-0 px-md-4 py-md-0">
        <div className="d-flex justify-content-between">
          <h2 className="title2">
            Risposte per: {sondaggio?.sonTitolo}
          </h2>
        </div>
        <Row className="g-2 my-4 align-items-center"> {/* g-2 aggiunge gutter (spazio) tra le colonne */}

          {/*<Col>
                        <Dropdown className="d-inline" autoClose="inside">
                            <Dropdown.Toggle id="dropdown-autoclose-outside">
                                <span className="px-5">Filtra</span>
                            </Dropdown.Toggle>
                            <Dropdown.Menu>

                            </Dropdown.Menu>
                        </Dropdown>

                    </Col>*/}
          <Col xs={12} md={7} lg={8}>
            <InputGroup> {/* Rimosso style maxHeight */}
              <InputGroup.Text id="basic-addon1">
                <GoSearch />
              </InputGroup.Text>
              <FormControl
                placeholder="Cerca domanda/sezione..."
                onChange={(ev) => { setDomDomanda(ev.target.value) }}
                aria-label="Cerca domanda o sezione" // Aggiunto per accessibilità
              />
            </InputGroup>
          </Col>
          <Col xs={12} md={5} lg={4} className="d-grid gap-2"> {/* d-grid per bottone full-width */}
            <Button
              variant="primary"
              onClick={esportaPDF}
              disabled={exportingPdf || caricandoSondaggioERisposte} // Disabilita durante export o caricamento
            >
              {exportingPdf ? (
                <>
                  <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-1" />
                  Esportando...
                </>
              ) : (
                <>
                  <PiFileCsv className="me-1" /> {/* Considera PiFilePdf */}
                  Esporta Report PDF
                </>
              )}
            </Button>
          </Col>

        </Row>
        {
          caricandoSondaggioERisposte ?
            (<>
              <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "40vh" }}>
                <Spinner animation="border" variant="primary" role="status" />
              </div>
            </>)
            :
            (<>
              <Row>
                <div className="mb-5">

                  <CardRispondenti

                    //totalePartecipantiSondaggio={totalePartecipantiSondaggio}
                    //partecipantiTotali={partecipantiTotali}
                    dataEtaPartecipante={dataEtaPartecipante}
                    datiGraficoTempo={datiGraficoTempo}
                    dataInizioSondaggio={dataInizioSondaggio}
                    dataFineSondaggio={dataFineSondaggio}
                    caricandoSondaggioERisposte={caricandoSondaggioERisposte}
                    tipoPunteggio={sondaggio.sonTipoPunteggio}
                    datiPunteggiGrafico={datiPunteggiGrafico}
                  />
                </div>
              </Row>


              {sezioniFiltrate.map(sezione => {
                const isDefined = sezioniVisibili.hasOwnProperty(sezione.sezId);
                const visibile = isDefined ? sezioniVisibili[sezione.sezId] : true; // Visibile se true o non definito

                return (
                  <div key={sezione.sezId} className="mb-5">
                    <div
                      className="rounded-top text-black px-3 py-2 mb-2 d-flex justify-content-between align-items-center"
                      style={{
                        backgroundColor: "#f0ecec",
                        borderTopLeftRadius: "0.5rem",
                        borderTopRightRadius: "0.5rem",
                      }}
                    >
                      <strong >
                        Sezione {sezione.sezPosizione} - {sezione.sezNome}
                      </strong>
                      <Button
                        variant="link"
                        className="text-black p-0"
                        onClick={() => toggleSezione(sezione.sezId)}
                        aria-label="Espandi/comprimi sezione"
                      >
                        {visibile ? "▲" : "▼"}
                      </Button>
                    </div>
                    {/*<div className={!visibile ? 'd-none' : ''}>*/}
                    {sezione.domande.slice() // Crea una copia superficiale per non mutare lo stato originale (best practice)
                      .sort((a, b) => (a.domNumPosizione ?? Infinity) - (b.domNumPosizione ?? Infinity)) // <-- ORDINA, ?? Infinity gestisce eventuali valori null o undefined mettendoli alla fine
                      .map((domanda, idx) => ( // ora mappa sull'array ordinato
                        <div>
                          {visibile ? (<>
                            <div
                              key={domanda.domId} // Chiave univoca
                              ref={el => { // Assegna il riferimento all'elemento DOM
                                if (el) {
                                  elementRefs.current[`pdf-domanda-${domanda.domId}`] = el;
                                } else {
                                  // Rimuovi il ref se l'elemento viene smontato (buona pratica)
                                  delete elementRefs.current[`pdf-domanda-${domanda.domId}`];
                                }
                              }}
                              id={`pdf-domanda-${domanda.domId}`} // Manteniamo ID per fallback/debug
                              className="pdf-export-section mb-4  bg-white" // Assicurati bg bianco per cattura
                            >

                              <DomandaGrafico
                                domanda={domanda}
                                risposte={risposte}
                                sezioneEspansa={sezioniEspanse[sezione.sezId]}
                                visibile={visibile}
                                numeroPartecipanti={totalePartecipantiSondaggio} // <-- Passa il totale
                              />

                            </div>
                          </>
                          ) : (

                            <>
                              <div
                                className="p-3 mb-3 border rounded shadow-sm"
                                style={{
                                  backgroundColor: "#fff",
                                  borderColor: "#000",      // bordo nero
                                  borderWidth: "1px",
                                  borderStyle: "solid",
                                  boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)" // shadow leggera
                                }}
                              >
                                <h6 className=" mb-1 fw-bold">
                                  D{domanda.domNumPosizione} - {domanda.domDomanda}
                                </h6>
                                <small className="text-muted">
                                  {domanda.tipoDomanda?.tipDomMultipla ? "Scelta multipla" : "Scelta singola"}
                                </small>
                              </div>

                            </>
                          )}
                        </div>

                      )

                      )}
                    {/*</div>*/}

                  </div>
                );
              })}


            </>)
        }





        <Row>
          <Container className="d-flex justify-content-between p-0 m-0 mt-4 mb-5">
            <Button variant="outline-dark" onClick={redirectToList}>
              <FiChevronLeft />
              Indietro
            </Button>

          </Container>
        </Row>
        {!caricandoSondaggioERisposte && sondaggio && risposte && ( // Assicurati che i dati ci siano
          <div style={{ position: 'absolute', left: '-9999px', top: 'auto', width: '700px', zIndex: '-1' }}> {/* Posizionato fuori schermo */}
            {sondaggio.sezioni // Itera su TUTTE le sezioni originali
              .sort((a, b) => a.sezPosizione - b.sezPosizione) // Ordina sezioni
              .map(sezione => (
                sezione.domande
                  .sort((a, b) => a.domNumPosizione - b.domNumPosizione) // Ordina domande
                  .map(domanda => (
                    // Questo div è quello che cattureremo
                    <div
                      key={`pdf-${domanda.domId}`} // Chiave unica per il rendering PDF
                      ref={el => { // Assegna il ref all'elemento corretto
                        if (el) {
                          pdfElementRefs.current[`pdf-domanda-${domanda.domId}`] = el;
                        } else {
                          delete pdfElementRefs.current[`pdf-domanda-${domanda.domId}`];
                        }
                      }}
                      id={`pdf-capture-${domanda.domId}`} // ID opzionale per debug
                    >
                      {/* Usa il NUOVO componente semplificato per il PDF */}
                      <DomandaGraficoPdfContent
                        domanda={domanda}
                        risposte={risposte}
                      // Non servono altre props come sezioneEspansa qui
                      />
                    </div>
                  ))
              ))}
          </div>
        )}
      </Container>
    </>
  );
}